import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const chargeTransactionApi = {
  // lay danh sach phien sac
  getChargeTransactionList: (params) => {
    const url = '/ct';
    return axiosClient.get(url, {
      params: Utils.filterParams({
        exclusionZeroCost: false,
        ...params,
      }),
    });
  },

  // lay thong tin chi tiet phien sac
  getChargeTransactionDetail: (chargeTransactionId) => {
    const url = `/ct/${chargeTransactionId}`;
    return axiosClient.get(url);
  },
};

export default chargeTransactionApi;
